import type { Button as ButtonPrimitive } from 'bits-ui'
import { type VariantProps, tv } from 'tailwind-variants'

export const buttonVariants = tv({
  base: 'ring-offset-background focus-visible:ring-ring inline-flex items-center justify-center whitespace-nowrap rounded-md text-sm transition-[color,background-color,border-color,transform] duration-150 ease-out active:scale-[0.98] focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-offset-2 disabled:pointer-events-none disabled:bg-white/[0.04] disabled:border-white/[0.07] disabled:text-silver/50 motion-reduce:active:scale-100',
  variants: {
    variant: {
      default: 'bg-primary text-primary-foreground hover:bg-white',
      destructive: 'bg-destructive text-destructive-foreground hover:bg-destructive/90',
      outline:
        'border border-white/[0.09] bg-white/[0.03] text-white shadow-[inset_0_1px_0_0_rgb(255_255_255/0.05)] hover:border-white/20 hover:bg-white/[0.07]',
      secondary: 'bg-secondary text-secondary-foreground hover:bg-secondary/80',
      ghost: 'hover:bg-accent hover:text-accent-foreground disabled:bg-transparent',
      link: 'text-primary underline-offset-4 hover:underline',
    },
    size: {
      default: 'h-10 px-4 py-2',
      sm: 'h-9 rounded-md px-3',
      lg: 'h-11 rounded-md px-8',
      icon: 'h-10 w-10',
    },
  },
  defaultVariants: {
    variant: 'default',
    size: 'default',
  },
})

type Variant = VariantProps<typeof buttonVariants>['variant']
type Size = VariantProps<typeof buttonVariants>['size']

export type Props = ButtonPrimitive.Props & {
  variant?: Variant
  size?: Size
}

export type Events = ButtonPrimitive.Events
